module.exports = __webpack_public_path__ + "static/media/BeVietnam-Regular.bd27b3ec.ttf";